import React from 'react';

interface Props {
	size: number;
}

export const LegalStudiesIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>legalStudies</title>
		<path d='M22.28 7.86H1.78a.42.42 0 010-.83h20.5a.42.42 0 110 .83z' />
		<path d='M12 7.86a.41.41 0 01-.41-.41V3.5a.41.41 0 01.41-.41.41.41 0 01.42.41v4a.42.42 0 01-.42.36zM8.79 18.38H.7a.43.43 0 01-.34-.18.41.41 0 010-.39l4-10.25a.43.43 0 01.77 0l4.05 10.25a.41.41 0 010 .39.44.44 0 01-.39.18zm-7.48-.83h6.87l-3.43-8.7z' />
		<path d='M4.75 20.91c-2 0-4-1.43-4.4-2.6l-.13-.43.43-.09a4.19 4.19 0 01.67-.09c.58-.05 1.18-.05 2.59-.05h4.21a3.91 3.91 0 01.64.09l.41.1-.11.41c-.32 1.22-2.37 2.66-4.31 2.66zM1.4 18.52a4.81 4.81 0 003.35 1.56A4.58 4.58 0 008 18.52c-.53 0-1.1-.05-2.47 0H3.91c-1.37-.05-1.91-.04-2.51 0zM23.36 18.38h-8.09a.4.4 0 01-.34-.18.42.42 0 010-.39l4-10.25a.44.44 0 01.77 0l4.05 10.25a.42.42 0 01-.05.39.4.4 0 01-.34.18zm-7.48-.83h6.87l-3.43-8.7z' />
		<path d='M19.32 20.91c-2 0-4.06-1.43-4.4-2.6l-.13-.43.43-.09a4 4 0 01.66-.09c.58-.05 1.19-.06 2.6-.05H22.68a3.6 3.6 0 01.64.09l.42.1-.11.41c-.32 1.22-2.37 2.66-4.31 2.66zM16 18.52a4.81 4.81 0 003.35 1.56 4.6 4.6 0 003.27-1.56c-.53 0-1.09-.05-2.47 0h-1.67c-1.37-.05-1.96-.04-2.48 0z' />
	</svg>
);
